<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.tagTemplates'), $t('text.list')]">
        <router-link :to="{ name: 'perferencePdmTagTemplatesNew' }">
          <el-button type="success" size="mini"
            >+ {{ $t("text.create") }}</el-button
          >
        </router-link>
      </breadcrumb>
    </div>

    <div class="wrapper table-area">
      <vxe-table
        :data="printTemplates"
        :loading="loading"
        id="printTemplateTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column field="name" :title="$t('text.name')" />
        <vxe-table-column field="action" :title="$t('text.action')" width="100">
          <template v-slot="{ row }">
            <router-link
              :to="{
                name: 'perferencePdmTagTemplatesEdit',
                params: { id: row.id },
              }"
              class="mgr10"
            >
              <el-button type="text" size="mini">{{
                $t("text.edit")
              }}</el-button>
            </router-link>
            <el-button type="text" size="mini" @click="deleteRow(row)">{{
              $t("text.delete")
            }}</el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import PrintTemplate from "@/api/printTemplate.js";

export default {
  mixins: [page],
  components: {},
  data() {
    return {
      type: "product",
      printTemplates: [],
    };
  },
  created() {
    const self = this;
    self.loadData();
  },
  methods: {
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(self.$t("prompt.confirmDelete"))) {
        PrintTemplate.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    loadData() {
      const self = this;
      self.loadingStart();
      PrintTemplate.findByType({ type: self.type }).then(function (res) {
        if (res.status === 200) {
          self.printTemplates = res.data;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
  },
};
</script>
<style scoped>
</style>